<ul class="nav nav-tabs mb-3">
  <li class="nav-item">
    <a class="nav-link pointer" [class.active]="activeTab === 'bulk-breakup'" (click)="switchTab('bulk-breakup')">Bulk
      Breakup</a>
  </li>
  <li class="nav-item">
    <a class="nav-link pointer" [class.active]="activeTab === 'mapping'" (click)="switchTab('mapping')">Bulk ↔ Child
      Mapping</a>
  </li>
</ul>

<!-- Bulk Breakup List Section -->
<div class="content-info" *ngIf="activeTab === 'bulk-breakup'">
  <div class="content-title d-flex flex-column flex-md-row align-items-md-center justify-content-between">
    <h3 class="title mb-3 mb-md-0">Bulk Breakup List</h3>
    <div class="title-actions d-flex flex-wrap align-items-center gap-2">
      <!-- Search Repack input -->
      <div class="form-group mb-0">
        <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()" placeholder="Search Repack Job Number..."
          class="form-control" style="min-width: 200px;" />
      </div>

      <!-- Create Bulk Breakup button -->
      <button class="btn btnprimary text-nowrap" [routerLink]="['/repack/create-repack']">
        <i class="bi bi-plus-lg"></i>Create Bulk Breakup
      </button>
    </div>
  </div>

  <div class="common-table">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Job Number</th>
            <th>Date</th>
            <th>Overhead Total</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @if(repacksLoading) {
          <tr>
            <td colspan="8" class="text-center">Loading repacks...</td>
          </tr>
          } @else { @if(!repackList.length) {
          <tr>
            <td colspan="8" class="text-center">No repacks found.</td>
          </tr>
          } @else { @for(repack of repackList; track repack.id) {
          <tr>
            <td>
              <a [routerLink]="['/repack/edit', repack.id]" [queryParams]="{ view: true }">
                {{ repack.jobNumber }}
              </a>
            </td>
            <td>{{ repack.date | date : "dd-MM-yy" }}</td>
            <td>{{ repack.overheadTotal || 0 | number }}</td>
            <td>
              <span class="badge" [ngClass]="
                    repack.status === 'POSTED' ? 'bg-success' : 'bg-warning'
                  ">
                {{ repack.status }}
              </span>
            </td>
            <td>
              <div class="td-actions-btn">
                @if (repack.status === 'DRAFT') {
                <button class="btn btn-edit" [routerLink]="['/repack/edit', repack.id]">
                  <i class="bi bi-pencil-square"></i>
                </button>
                }
                <button class="btn btn-download">
                  <i class="bi bi-file-earmark-pdf"></i>
                </button>
              </div>
            </td>
          </tr>
          } } }
        </tbody>
      </table>
    </div>

    <div class="table-pagination">
      <div class="pagination-count">
        <select [(ngModel)]="pageSize" (change)="pageSizeChange()">
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
          <option value="40">40</option>
        </select>
        <span>entries per page</span>
      </div>
      <ul class="pagination">
        <!-- Previous button -->
        <li class="page-item" [class.disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
          <a class="page-link">&laquo;</a>
        </li>

        <!-- First Page button -->
        <li class="page-item" [class.active]="currentPage === 1" (click)="goToPage(1)">
          <a class="page-link">1</a>
        </li>

        <!-- Left Ellipsis -->
        @if (currentPage > 4) {
        <li class="page-item disabled">
          <a class="page-link">...</a>
        </li>
        }

        <!-- Pages Around Current page -->
        @for (page of getVisiblePages(); track page) {
        <li class="page-item" [class.active]="page === currentPage" (click)="goToPage(page)">
          <a class="page-link">{{ page }}</a>
        </li>
        }

        <!-- Right Ellipsis -->
        @if (currentPage < pageCount - 3) { <li class="page-item disabled">
          <a class="page-link">...</a>
          </li>
          }

          <!-- Last Page button - only show if more than 1 page -->
          @if (pageCount > 1) {
          <li class="page-item" [class.active]="currentPage === pageCount" (click)="goToPage(pageCount)">
            <a class="page-link">{{ pageCount }}</a>
          </li>
          }

          <!-- Next button -->
          <li class="page-item" [class.disabled]="currentPage === pageCount" (click)="goToPage(currentPage + 1)">
            <a class="page-link">&raquo;</a>
          </li>
      </ul>
    </div>
  </div>
</div>

<div class="content-info" *ngIf="activeTab === 'mapping'">
  <div class="content-title">
    <h3 class="title">Bulk ↔ Child Mapping</h3>
  </div>
  <app-bulk-child-mapping></app-bulk-child-mapping>
</div>